export default __webpack_public_path__ + "static/media/pass-through.8b5abad2.svg";